import styled from 'styled-components';
import { colors } from 'spw-theme';

export const DownloadOptionsHeader = styled.div`
  && {
    padding: 16px 16px 8px 16px;
    font-size: 12px;
    font-style: normal;
    font-weight: 900;
    line-height: 16px;
    color: ${colors.spaceCategoriesOther};
  }
`;
